import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import ARRAY from "../../../UTIL/ARRAY";
import { log } from "../../../UTIL/LOG";
import GameInstance from "../GameInstance";
 
class GameData
{
    private conquer         : CONQUER;
    public tabs             : any;
    private vars            : any = {};
    public data             : any = {};
    private gameID          : any;
    private version         : any = 1;
    private dirty           : any = false;
    private interval        : any;
    private gameInstance    : GameInstance;
    private isInitialized   : boolean = false;

    constructor( gameInstance :GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.conquer        = gameInstance.conquer;
    }

    public setVersion( vars?:any )
    {

    };

    public async init( data:any ) : Promise<any>
    {
        this.data           = data;

        this.gameID         = this.gameInstance.gameID;
        this.vars           = { gameID:this.gameID };
  
        this.stop();
  
        let self            = this;
        let conquer         = this.conquer;
        let gameID          = this.gameID;
 
        this.interval = setInterval( function()
        {
            if( !self.dirty ) return;
 
            conquer.do( ACTIONS.GAME_DATA_SET, { gameID:gameID, value:self.dirty } )
            
            //.then( function(e){
            //    console.log("SAVED DATA", e );
            //}); 

            self.dirty  = false;

        }, 1000 );

        this.conquer.Haptic.setEnabled( !this.get("vibration") );
 
        return Promise.resolve( data );
    }
 
    public get( name:string )
    {
        return this.data[ name ] || 0;
    }

    public async getPublic( avatarID:any, names:any )
    {
        let results     = await this.conquer.do( ACTIONS.GAME_DATA_GET, { gameID:this.gameID, avatarID:avatarID, names:names });
        return Promise.resolve( results );
    }

    public set( name:string, value:any )
    {
        return this.display( name, value, true );
    }

    public increase( name:string, value:any=1 ) 
    {
        return this.set( name, this.get( name ) + value );
    }

    public decrease( name:string, value:any ) 
    {
        return this.set( name, -value );
    }

    public display( name:string, value:any, andSave?:boolean )
    {
        this.data[ name ] = value;
        this.gameInstance.Signal.set( name, value );

        if( andSave )
        {
            if( !this.dirty ) this.dirty = {};
            this.dirty[ name ] =  value;
        }

        return value;
    }

    public displayIncrease( name:string, value:any ) 
    {
        return this.display( name, this.get( name ) + value );
    }

    public displayDecrease( name:string, value:any ) 
    {
        return this.displayIncrease( name, -value );
    }
 
    public increaseTotal( name:string, value:any=1 )
    {   
        var totalName   = "total" + name;
        var newVal      = this.increase( totalName, value );
 
        this.setMax( name, newVal );
    };
    
    public increaseMax( name:string, value:any=1 )
    {
        this.increase( name, value );
        this.setMax( name );
    }

    public setMax( name:string, value:any=1  )
    {   
        var maxName     = "max"+ name;
        var currVal     = this.get( maxName );
        
        if( currVal > value ) return;

        this.set( maxName, value );
    };

  
    public async remove( vars?:any ) : Promise<any>
    {
        for( let n in this.data ) delete this.data[ n ];
        
        vars            = vars || {};
        vars.gameID     = this.gameID;
        let results     = await this.conquer.do( ACTIONS.GAME_DATA_REMOVE, vars );

        return Promise.resolve( results );
    }

    public reset()
    {
        this.remove();
    }

    public stop()
    {
        clearInterval( this.interval );
    }
}

export default GameData;